exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v--modal-overlay[data-v-3e7ef9aa] {\n  background-color: rgba(0,0,0,0.7);\n}\n.video[data-v-3e7ef9aa] {\n  width: 100%;\n  height: 100%;\n}\n\n", ""]);

// exports
